import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

let auth = "";
let decoded = "";
const date = new Date();
export const GuardedRoute = () => {
  auth = localStorage.getItem("auth_token_travel");
  if (auth) {
    decoded = jwtDecode(auth);
    var expiry = decoded.exp * 1000;
    var current = Date.now();
    if (current >= expiry) {
      auth = null;
      localStorage.clear();
    }
  }
  return auth ? <Outlet /> : <Navigate to="/" replace={true} />;
};

export const GuardedLogin = () => {
  return !localStorage.getItem("auth_token_travel") ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard" replace={true} />
  );
};
